import {createContext} from 'react';
import {PayoutTypes} from '../../../shared/types';

interface CloseAccountContextValue {
    isRendering?: boolean;
    isLoading?: boolean;
    payoutTypeSelected: PayoutTypes;
    amount: number;
    formattedAmount: string;
}

export const CloseAccountContext = createContext<CloseAccountContextValue>({
    isRendering: false,
    isLoading: false,
    payoutTypeSelected: null,
    amount: 0,
    formattedAmount: null
});
